import Drawer from '@mui/material/Drawer';
import { SxProps } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

import GratiNavList from './GratiNavList';

interface GratiNavRailProps {
  sx?: SxProps<Theme>;
}

export default function GratiNavRail(props: GratiNavRailProps) {
  const sx = props.sx;

  return (
    <Drawer variant="permanent" sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <Toolbar sx={{ py: 0, my: 0, height: 0 }} />
      <GratiNavList resetReactRoutes />
    </Drawer>
  );
}
